import { OverflowDropdown } from "Components/Generic/OverflowDropdown";
import { getTranslatedFieldLabel } from "Utils/Field";
import { getItemType } from "Utils/Item";
import { IEditFieldProps } from "../IEditFieldProps";
import { useEditOption } from "./UseEditOption";

export function EditOption(props: IEditFieldProps): JSX.Element {
  const {
    htmlId, fieldName, item, translator, disabled
  } = props;
  const additionalProps = useEditOption(props);
  return (
    <OverflowDropdown
      id={htmlId}
      placeholder={`${getTranslatedFieldLabel(`${fieldName}.option.placeholder`, getItemType(item), translator)}...`}
      disabled={disabled}
      {...additionalProps}
    />
  );
}
